// used for mock response when running in our test env
import {mockResponse} from '../responseHelper'

const jsonPayload = {
    books: [
        {
            bookId: 18592,
            title: 'Some title',
            isOfficial: true,
            readingLevel: '5-6'
        },
        {
            bookId: 543682,
            title: "Bizarre dinosaurs: some very strange creatures and why we think they got that way",
            author: "Michael",
            yearPublished: 0,
            pageCount: 0,
            positionInSeries: 0,
            averageRating: 0,
            challengeYear: 0,
            difficultRead: true,
            imagePresent: true,
            imageCoverUrl: "https://i.pinimg.com/736x/99/f2/e1/99f2e10beeecd4f3a1a7e059d4b54491--beginner-books-childhood-memories.jpg",
            isNew: "F",
            type: "CHOICE",
            isOfficial: true,
            readingLevel: '5-6'            
        }
    ]
};

export default function (options) {
    if (options.method === 'POST') {
        jsonPayload.books.unshift(JSON.parse(options.body))
    }
    if (options.method === 'DELETE') {
        jsonPayload.books = jsonPayload.books.filter(b => b.bookId !== options.bookId);
    }
    return Promise.resolve(mockResponse('application/json', jsonPayload))
}
